import jMoment from 'moment-jalaali';
import { numberWithCommas } from 'utility';
import WITHDRAW_TYPES from '../../constants/ruleTypes';

const columns = (currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false, // TODO: turn it false after QCTest of Table Pod
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'مشتری',
    field: 'user',
    filtering: false,
    sorting: false,
    render: (rd) => rd?.user?.name ?? '-',
  },
  {
    title: 'نوع مجوز',
    field: 'typeCode',
    filtering: false,
    sorting: false,
    render: (rd) =>
      rd?.typeCode ? WITHDRAW_TYPES.find((v) => v?.value === rd.typeCode)?.label ?? '-' : '-',
  },
  {
    title: 'تاریخ ایجاد',
    field: 'creationDate',
    filtering: false,
    sorting: false,
    render: (rc) => jMoment(rc?.creationDate).format('jYYYY/jM/jD'),
  },
  {
    title: 'تاریخ شروع',
    field: 'startDate',
    filtering: false,
    sorting: false,
    render: (rc) => (rc?.startDate ? jMoment(rc?.startDate).format('jYYYY/jM/jD') : '-'),
  },
  {
    title: 'تاریخ انقضا',
    field: 'expireDate',
    filtering: false,
    sorting: false,
    render: (rc) => (rc?.expireDate ? jMoment(rc?.expireDate).format('jYYYY/jM/jD') : '-'),
  },

  {
    title: `مبلغ برداشت شده/سقف برداشت - ${currencyText}`,
    field: 'usageAmount',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) =>
      rd?.usageAmount === undefined && rd?.maxAmount === undefined
        ? 'نامحدود'
        : `${numberWithCommas(rd?.usageAmount ?? 0)} / ${
            rd?.maxAmount ? numberWithCommas(rd?.maxAmount) : '∞'
          }`,
  },

  {
    title: 'دفعات برداشت شده/سقف دفعات',
    field: 'usageCount',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) =>
      rd?.usageCount === null && rd?.maxCount === null
        ? '-'
        : `${numberWithCommas(rd?.usageCount ?? 0)} / ${
            rd?.maxCount ? numberWithCommas(rd?.maxCount) : '∞'
          }`,
  },

  {
    title: 'وضعیت',
    field: 'active',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rd) => (rd?.active ? 'فعال' : 'غیرفعال'),
    subRows: [{ age: 'تست ۱', visits: 'تست ۲', status: 'تست ۳', progress: 'تست ۴' }],
  },
];

const columnsId = {};

const orderingIndexes = [
  null,
  'زمان شروع',
  'زمان انقضا',
  'نام و نام خانوادگی',
  'میزان',
  'استفاده شده',
  'تعداد شارژ مجدد',
  'وضعیت',
  null,
  null,
  null,
];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, columnsId, generateData, orderingIndexes };
